import { LayoutGridItem } from '@cko/primitives';
import styled from 'styled-components';

export const TopBarContainer = styled(LayoutGridItem)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--layout-stamp) var(--layout-shoe);
  border-bottom: var(--border-b-seed) solid var(--base-border-secondary);
  background: var(--base-bg-primary);
  z-index: var(--z-order-navigation);
  position: sticky;
  top: 0;
  height: 60px;
`;
